'use client'
import React, { ReactNode, useEffect, useState } from 'react'
import CustomModal from '../CustomModal'
import { Box, Button, Checkbox } from '@mui/material'

export default function Terms ({ children }: { children: ReactNode }): JSX.Element {
  const [readTerms, setReadTerms] = useState(false)
  const [agreeTerms, setAgreeTerms] = useState(false)
  const [showTerms, setShowTerms] = useState(false)
  const currentTOSVersion = process.env.NEXT_PUBLIC_APP_TOS_VERSION

  useEffect(() => {
    const savedTermsVersion = localStorage.getItem('tosVersion')
    if (
      !savedTermsVersion ||
      !currentTOSVersion ||
      savedTermsVersion !== currentTOSVersion
    ) {
      setShowTerms(true)
    }
  }, [currentTOSVersion])

  const confirmTOS = (): void => {
    localStorage.setItem('tosVersion', currentTOSVersion ?? '')
    setShowTerms(false)
  }

  if (showTerms) {
    return (
      <CustomModal open={showTerms} classname='w-[400px] md:w-[500px]'>
        <div className='w-fit h-fit p-5'>
          <h5 className='text-2xl font-regular mb-4'>Terms of Service</h5>
          <Box my={2} className='max-w-fit'>
            <p className='font-regular'>
              Before using BubbleFi, please carefully read and agree to our <a href='https://docs.monadex.exchange/references/terms-of-use' className='text-primary font-clash underline' target='_blank' rel='noopener noreferrer'>Terms of Service.</a> Your use of our platform is subject to these terms.
            </p>
          </Box>
          <Box className='flex items-start my-4'>
            <Checkbox
              checked={readTerms}
              onChange={() => setReadTerms(!readTerms)}
              sx={{
                color: '#836EF9',
                '&.Mui-checked': {
                  color: '#836EF9'
                }
              }}
            />
            <p className='ml-2 opacity-80'>
              I confirm that I have read, understood, and agree to be bound by the BubbleFi Terms of Service, including all disclaimers and risk warnings contained therein.
            </p>
          </Box>
          <Box className='flex items-start my-4'>
            <Checkbox
              checked={agreeTerms}
              onChange={() => setAgreeTerms(!agreeTerms)}
              sx={{
                color: '#836EF9',
                '&.Mui-checked': {
                  color: '#836EF9'
                }
              }}
            />
            {/*  I acknowledge that using BubbleFi involves risks, including but not limited to the risk of loss of funds. I understand and accept these risks, and */}
            <p className='ml-2 opacity-80'>
              I acknowledge that using BubbleFi on testnet involves no real money and it's only for test purposes and I agree to use the platform at my own discretion and risk.
            </p>
          </Box>
          <Box mt={4}>
            <button
              disabled={!readTerms || !agreeTerms}
              onClick={confirmTOS}
              className='w-full bg-primary py-4 px-4 rounded-md disabled:opacity-20 bg-opacity-90 text-lg mt-5'
            >
              I Agree to the Terms of Service
            </button>
          </Box>
        </div>
      </CustomModal>
    )
  }

  return <>{children}</>
}
